import * as React from 'react';
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {FalconPaymentRequest, ICustomerPortalService, Types, VerifyNewCardResponse, PROCESS_PAY_OFF_BALANCE, ICacheManager} from "@falcon/services";
import {getProductByPolicyNumber, getSessionStorage} from "../../../../../CommonFunctions";
import {Navigate} from "react-router-dom";

interface IPageParams {
    policyNumber: string;
    paymentReference: string;
    [key: string]: string | undefined;
}

interface IState {
   paymentFailed?: boolean;
   paymentCancelled?: boolean;
}

@authorize
export class PayOffBalanceProcessingPagePlain extends React.Component<IWithRouterProps<IPageParams>, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    @lazyInject(Types.CacheManager)
    private cacheManager: ICacheManager;

    constructor(props: IWithRouterProps<IPageParams>) {
        super(props);

        this.state = {}
    }

    public componentDidMount(): void {
        const policyNumber: string = this.props.params.policyNumber;
        const reuseCard: any = getSessionStorage("reuseCard") || false;
        const request: FalconPaymentRequest = new FalconPaymentRequest();
        request.invoiceType = "PAYOFF";
        request.product = getProductByPolicyNumber(policyNumber);

        if (this.props.params.paymentReference) {
            this.customerPortalService.payOffBalanceWithNewCard(request, policyNumber, this.props.params.paymentReference, reuseCard).subscribe((response: VerifyNewCardResponse) => {

                if (response.successful) {
                    window.sessionStorage.setItem("showPopup", "true");
                    window.sessionStorage.setItem("referrerJourney", PROCESS_PAY_OFF_BALANCE);

                    this.cacheManager.clearCache(`getPolicyPropertyByPropertyKey${policyNumber},mainAnnualPaymentCard`);
                    this.cacheManager.clearCache(`getAnnualPolicyInfo${policyNumber}`);

                    window.location.href = `/dashboard/monthlyPaymentHistory/${policyNumber}`;
                } else if (response.cancelled) {
                    this.setState({
                        paymentCancelled: true
                    })
                } else {
                    this.setState({
                        paymentFailed: true
                    })
                }
            })
        }
    }

    public render(): React.ReactNode {
        if (this.state.paymentFailed) {
            return <Navigate to={`/dashboard/${this.props.params.policyNumber}/payOffBalance/newCard`} state={{
                paymentFailed: this.state.paymentFailed
            }}/>
        } else if (this.state.paymentCancelled) {
            return (
                <Navigate to={{
                    pathname: `/dashboard/monthlyPaymentHistory/${this.props.params.policyNumber}`
                }} />
            )
        } else {
            return <Overlay show={true}/>
        }
    }
}

export const PayOffBalanceProcessingPage = withRouter<{}, IPageParams>(PayOffBalanceProcessingPagePlain)
